// Module
var code = `<div class="prints-details__content">
  <div>
    <form name="\$ctrl.printForm">
      <h2 class="section-header">General configuration for {{\$ctrl.getPrintName()}}</h2>
      <prints-details-general-configuration
        print="\$ctrl.print"
        print-parameters="\$ctrl.printParameters"
        on-change="\$ctrl.onChange"
        print-form="\$ctrl.printForm"
      >
      </prints-details-general-configuration>

      <div ng-if="\$ctrl.print.type === 'COORDINATE'">
        <h2 class="section-header">Variables configuration</h2>
        <prints-details-variable-configuration
          print="\$ctrl.print"
          print-parameters="\$ctrl.printParameters"
          on-change="\$ctrl.onChange"
        >
        </prints-details-variable-configuration>

        <h2 class="section-header">Label configuration</h2>
        <prints-details-label-configuration
          print="\$ctrl.print"
          print-parameters="\$ctrl.printParameters"
          on-change="\$ctrl.onChange"
          add-label="\$ctrl.addLabel"
          new-label="\$ctrl.newLabel"
        >
        </prints-details-label-configuration>

        <h2 class="section-header">Custom variable configuration</h2>
        <prints-details-custom-variable-configuration
          print="\$ctrl.print"
          on-change="\$ctrl.onChange"
        ></prints-details-custom-variable-configuration>
      </div>

      <div ng-if="\$ctrl.print.type === 'TEMPLATE'">
        <h2 class="section-header">Variables</h2>
        <prints-details-template-variable-configuration
          print="\$ctrl.print"
          on-change="\$ctrl.onChange"
        >
        </prints-details-template-variable-configuration>

        <h2 class="section-header">Custom variable configuration</h2>
        <prints-details-custom-variable-configuration
          print="\$ctrl.print"
          on-change="\$ctrl.onChange"
        ></prints-details-custom-variable-configuration>

        <div class="alert" ng-non-bindable>
          To use variable in editor or file use {{variableName}} syntax. For more details on what is possible, please refer to https://handlebarsjs.com.
        </div>

        <h2 class="section-header">Editor</h2>

        <wysiwyg-editor ng-if="\$ctrl.print.templateEditorType === 'WYSIWYG'"
          ng-model="\$ctrl.print.template"
          ng-change="\$ctrl.onChange()"
        >
        </wysiwyg-editor>

        <prints-details-template-upload ng-if="\$ctrl.print.templateEditorType === 'HTML'"
                        ng-model="\$ctrl.print.template"
                        ng-change="\$ctrl.onChange()"
        >
        </prints-details-template-upload>
      </div>
    </form>
  </div>
  <div class="summary-actions">
    <button
      type="button"
      class="btn btn-warning"
      ng-click="\$ctrl.cancel()">
      Cancel
    </button>
    <button
      type="button"
      class="btn btn-success"
      ng-disabled="\$ctrl.printForm.\$invalid || \$ctrl.print.isProcessing"
      ng-click="\$ctrl.save()">
      Save
    </button>
  </div>
  <h2 class="section-header">Preview</h2>
  <div class="clearfix"></div>
  <div id="prints-details__pdfWrapper">
    <iframe id="prev" class="prints-details__iframe-preview" type="application/pdf" style="" frameBorder="0">
    </iframe>
    <iframe id="hidden" class="prints-details__iframe-hidden" type="application/pdf" style="" frameBorder="0">
    </iframe>
  </div>
</div>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/prints/prints-details.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;